import { render, staticRenderFns } from "./ProfilBU.vue?vue&type=template&id=7e4abfd8&scoped=true&"
import script from "./ProfilBU.vue?vue&type=script&lang=js&"
export * from "./ProfilBU.vue?vue&type=script&lang=js&"
import style0 from "./ProfilBU.vue?vue&type=style&index=0&id=7e4abfd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4abfd8",
  null
  
)

export default component.exports